import React from 'react';
import { useSiteSettings } from '../hooks/useSiteSettings';

interface MaintenancePageProps {
  message?: string;
}

const MaintenancePage: React.FC<MaintenancePageProps> = ({
  message = "Site en maintenance. Nous revenons bientôt !"
}) => {
  // La page de maintenance s'affiche justement quand le site est en travaux :
  // useSiteSettings retombe sur ses valeurs par défaut si l'API ne répond pas,
  // pour que l'adresse de contact reste visible en toutes circonstances.
  const { contactEmail } = useSiteSettings();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        {/* Logo Phoelynx */}
        <div className="mb-8">
          <img
            src="/Phoelynx.png"
            alt="Phoelynx France"
            className="w-32 h-32 mx-auto object-contain"
          />
        </div>

        {/* Titre */}
        <h1 className="text-2xl font-bold text-gray-800 mb-4">
          Maintenance en cours
        </h1>

        {/* Message de maintenance */}
        <p className="text-gray-600 mb-6 leading-relaxed">
          {message}
        </p>

        {/* Icône de maintenance */}
        <div className="mb-6">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full">
            <svg
              className="w-8 h-8 text-blue-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
          </div>
        </div>

        {/* Info de contact */}
        <div className="text-sm text-gray-500">
          <p>Besoin d'aide ?</p>
          <p>
            Contactez-nous :
            <a
              href={`mailto:${contactEmail}`}
              className="text-blue-600 hover:text-blue-800 ml-1"
            >
              {contactEmail}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;